export var ChatParticipantStatus;
(function (ChatParticipantStatus) {
    ChatParticipantStatus[ChatParticipantStatus["TALKING"] = 10] = "TALKING";
    ChatParticipantStatus[ChatParticipantStatus["LEFT"] = 20] = "LEFT";
    ChatParticipantStatus[ChatParticipantStatus["PENDING_OUTBOUND"] = 30] = "PENDING_OUTBOUND";
})(ChatParticipantStatus || (ChatParticipantStatus = {}));
//# sourceMappingURL=chat-participant-status.enum.js.map